import { Button, Card, Descriptions, message, PageHeader, Tabs, Tag } from 'antd'
import { SupportApi } from 'api/Support'
import History from 'components/Common/History'
import TimelineFeedCont from 'components/Common/TimelineFeed/TimelineFeedCont'
import RefreshButton from 'elements/Buttons/RefreshButton'
import CustomSpin from 'elements/CustomSpin'
import FormSectionTitle from 'elements/FormSectionTitle'
import useActions from 'elements/Hooks/useActions'
import useFetch from 'elements/Hooks/useFetch'
import { isEmpty, pick } from 'lodash'
import moment from 'moment'
import React from 'react'
import { withRouter } from 'react-router-dom'

function SupportTicketCont(props) {
  const key = props.match.params.key

  const { data, fetching, fetch, setData } = useFetch({
    url: `support/${key}`,
    dontFetch: isEmpty(key),
    dependencyArray: [key],
  })

  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'newsletter',
    data,
    setData,
    SupportApi.operation
  )

  async function onAction(operation) {
    let hide = message.loading('', 0)
    await submitOperation({ status: operation, ...pick(data, ['_key', '_rev', '_id']) })
    fetch()
    hide()
  }

  return (
    <CustomSpin spinning={fetching}>
      <div className="space-y-2">
        <PageHeader
          ghost={false}
          onBack={() => props.history.push({ pathname: `/support` })}
          title={data.code}
          tags={<Tag color="blue">{data.status}</Tag>}
          subTitle={data.priority}
          extra={[
            <Button disabled={data.status === 'Solved'} onClick={() => onAction('solved')} key="solved" type="primary">
              Solved
            </Button>,
            <Button disabled={data.status === 'Pending'} onClick={() => onAction('pending')} key="pending">
              Pending
            </Button>,
            <Button disabled={data.status === 'Closed'} onClick={() => onAction('closed')} key="closed" type="danger">
              Closed
            </Button>,
            <RefreshButton onClick={fetch} />,
          ]}
        />
        <Card>
          <Tabs defaultActiveKey="details">
            <Tabs.TabPane tab="Details" key="details">
              <div className="space-y-20 flex flex-col">
                <Descriptions title="Ticket Info" bordered>
                  <Descriptions.Item label="Realm">{data.realm}</Descriptions.Item>
                  <Descriptions.Item label="Date">{moment(data.date).format('YYYY-MM-DD')}</Descriptions.Item>
                  <Descriptions.Item label="Type">{data.type}</Descriptions.Item>
                  <Descriptions.Item label="Member">{data?.member?.fn}</Descriptions.Item>
                  <Descriptions.Item label="Priority">{data.priority}</Descriptions.Item>
                  <Descriptions.Item label="URL" span={3}>
                    {data.url}
                  </Descriptions.Item>
                  <Descriptions.Item label="Description" span={3}>
                    <div className="text-left" style={{ whiteSpace: 'pre-line' }}>
                      {data.description}
                    </div>
                  </Descriptions.Item>
                </Descriptions>

                <div>
                  <FormSectionTitle title={'Comments'} />
                  <TimelineFeedCont owner={data._id} dependency={[fetching]} hideNotification
                                    submitNotification={() => onAction('note')} />
                </div>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="History" key="history">
              <History owner={data} key={data._rev} isArray={true} />
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </div>
    </CustomSpin>
  )
}

export default withRouter(SupportTicketCont)
